import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import store from '../store';

Vue.use(VueRouter);

function requireAuth(to, from, next) {
  if (store.state.token) {
    next();
    return;
  }

  next({ path: '/signin' });
}

const routes = [
  {
    path: '/',
    redirect: '/signin',
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { public: true },
  },
  {
    path: '/search',
    component: () =>
      import(/* webpackChunkName: "search" */ '../views/search/Search.vue'),
    meta: { public: true },
    children: [
      {
        path: '/search/domestic',
        name: 'Domestic',
        meta: { public: true },
        component: () =>
          import(
            /* webpackChunkName: "search" */ '../views/search/Domestic.vue'
          ),
      },
      {
        path: '/search/oversea',
        name: 'Oversea',
        meta: { public: true },
        component: () =>
          import(
            /* webpackChunkName: "search" */ '../views/search/Oversea.vue'
          ),
      },
    ],
  },
  {
    path: '/term/:idx',
    name: 'Terms',
    meta: { public: true },
    component: () =>
      import(
        /* webpackChunkName: "mypage" */ '../views/mypage/TermsDetail.vue'
      ),
  },
  // 마이페이지
  {
    path: '/mypage',
    name: 'Mypage',
    component: () =>
      import(/* webpackChunkName: "mypage" */ '../views/mypage/Home.vue'),
  },
  {
    path: '/mypage/history',
    name: 'History',
    component: () =>
      import(/* webpackChunkName: "mypage" */ '../views/mypage/History.vue'),
  },
  {
    path: '/myinfo',
    name: 'MyInfo',
    component: () =>
      import(/* webpackChunkName: "MyInfo" */ '../views/mypage/MyInfo.vue'),
  },
  {
    path: '/mypage/calculate',
    name: 'Calculate',
    component: () =>
      import(/* webpackChunkName: "mypage" */ '../views/mypage/Calculate.vue'),
  },
  {
    path: '/mypage/giftcard',
    name: 'GiftCard',
    component: () =>
      import(/* webpackChunkName: "mypage" */ '../views/mypage/GiftCard.vue'),
  },
  {
    path: '/mypage/profile',
    name: 'Profile',
    component: () =>
      import(/* webpackChunkName: "mypage" */ '../views/mypage/Profile.vue'),
  },
  {
    path: '/mypage/item',
    name: 'ITEM',
    component: () =>
      import(/* webpackChunkName: "mypageitem" */ '../views/mypage/Item.vue'),
  },
  {
    path: '/mypage/setting',
    name: 'Setting',
    component: () =>
      import(/* webpackChunkName: "mypage" */ '../views/mypage/Setting.vue'),
  },
  {
    path: '/opt-out',
    name: 'OptOut',
    component: () =>
      import(/* webpackChunkName: "shop" */ '../views/mypage/OptOut.vue'),
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: () =>
      import(
        /* webpackChunkName: "statistics" */ '../views/statistic/Statistics.vue'
      ),
  },

  {
    path: '/bookmarks',
    name: 'Bookmarks',
    component: () =>
      import(/* webpackChunkName: "mypage" */ '../views/mypage/Bookmarks.vue'),
  },
  {
    path: '/franchisee',
    name: '매장관리',
    component: () =>
      import(
        /* webpackChunkName: "mypagefranchisee" */ '../views/mypage/Franchisee.vue'
      ),
  },
  {
    path: '/manager',
    name: '관리자관리',
    component: () =>
      import(
        /* webpackChunkName: "mypagemanager" */ '../views/mypage/Manager.vue'
      ),
  },

  // 고객센터
  {
    path: '/cs/inquiry/write',
    name: 'CsInquiryWrite',
    component: () =>
      import(/* webpackChunkName: "cs" */ '../views/cs/InquiryWrite.vue'),
  },
  {
    path: '/cs/inquiry/list',
    name: 'CsInquiryList',
    component: () =>
      import(/* webpackChunkName: "cs" */ '../views/cs/InquiryList.vue'),
  },
  {
    path: '/cs/faq',
    name: 'CsFaq',
    meta: { public: true },
    component: () => import(/* webpackChunkName: "cs" */ '../views/cs/Faq.vue'),
  },
  {
    path: '/cs/notice',
    name: 'CsNotice',
    meta: { public: true },
    component: () =>
      import(/* webpackChunkName: "cs" */ '../views/cs/Notice.vue'),
  },
  {
    path: '/cs/notice/:code',
    name: 'CsNoticeDetail',
    meta: { public: true },
    component: () =>
      import(/* webpackChunkName: "cs" */ '../views/cs/NoticeDetail.vue'),
  },

  // 로그인&회원가입
  {
    path: '/signin',
    name: 'SignIn',
    meta: { public: true },
    component: () =>
      import(/* webpackChunkName: "sign" */ '../views/sign/SignIn.vue'),
  },
  {
    path: '/find-pw',
    name: 'FindPw',
    meta: { public: true },
    component: () =>
      import(/* webpackChunkName: "sign" */ '../views/sign/FindPw.vue'),
  },
  {
    path: '/find-id',
    name: 'FindId',
    meta: { public: true },
    component: () =>
      import(/* webpackChunkName: "sign" */ '../views/sign/FindId.vue'),
  },

  // ========================가맹점=================================

  {
    path: '/payment',
    name: 'PaymentForm',
    meta: { public: true },
    component: () =>
      import(
        /* webpackChunkName: "payment" */ '../views/payment/PaymentForm.vue'
      ),
  },
  {
    path: '/coupon/payment/:code',
    name: 'CouponPaymentCode',
    beforeEnter: requireAuth,
    component: () =>
      import(
        /* webpackChunkName: "Couponpayment" */ '../views/payment/CouponPayment.vue'
      ),
  },
  {
    path: '/point/payment/:code',
    name: 'PointPaymentCode',
    beforeEnter: requireAuth,
    component: () =>
      import(
        /* webpackChunkName: "PointPayment" */ '../views/payment/PointPayment.vue'
      ),
  },
  {
    path: '/payment/receipt/:code',
    name: 'PaymentReceipt',
    beforeEnter: requireAuth,
    component: () =>
      import(
        /* webpackChunkName: "payment" */ '../views/payment/PaymentReceipt.vue'
      ),
  },

  {
    path: '/terms/:idx',
    name: 'TermsDetail',
    meta: { public: true },
    component: () =>
      import(/* webpackChunkName: "cs" */ '../views/mypage/TermsDetail.vue'),
  },
  {
    path: '/user/:idx',
    name: 'UserDetail',
    component: () =>
      import(/* webpackChunkName: "customer" */ '../views/cs/UserDetail.vue'),
  },
  {
    path: '/reservation/wait',
    name: 'ReservationWait',
    component: () =>
      import(
        /* webpackChunkName: "reserve" */ '../views/reservation/ReservationWait.vue'
      ),
  },
  {
    // 2026-07-31: 구식 H→P→Y 결제요청 흐름 - 지금 이 상태로 대기 중인 예약이 DB에 0건이라
    // 사실상 죽은 화면(사용자 확인 완료). 컴포넌트/백엔드 코드는 그대로 남겨두고 라우트
    // 진입만 막는다 - 혹시 남아있을 구링크/북마크로 들어와도 빈 화면 대신 예약대기 목록으로 보낸다.
    path: '/reservation/payment/:code',
    name: 'ReservationPayment',
    redirect: '/reservation/wait',
  },
  {
    path: '/reservation/edit/:code',
    name: 'ReservationPaymentEdit',
    redirect: '/reservation/wait',
  },
  {
    path: '/reservation/cancel',
    name: 'ReservationCancel',
    component: () =>
      import(
        /* webpackChunkName: "reserve" */ '../views/reservation/ReservationCancel.vue'
      ),
  },
  {
    path: '/reservation/confirm',
    name: 'ReservationConfirm',
    component: () =>
      import(
        /* webpackChunkName: "reserve" */ '../views/reservation/ReservationConfirm.vue'
      ),
  },
  {
    path: '/reservation/detail/:code',
    name: '',
    component: () => import('../views/reservation/ReservationDetail.vue'),
  },
  {
    path: '/reservation/history/:date',
    name: 'ReservationHistory',
    component: () =>
      import(
        /* webpackChunkName: "reserve" */ '../views/reservation/ReservationHistory.vue'
      ),
  },
  {
    path: '/history/today/confirm',
    name: 'HistoryTodayConfirm',
    component: () =>
      import(
        /* webpackChunkName: "historyTodayConfirm" */ '../views/history/TodayConfirm.vue'
      ),
  },
  {
    path: '/history/today/cancel',
    name: 'HistoryTodayCancel',
    component: () =>
      import(
        /* webpackChunkName: "historyTodayCancel" */ '../views/history/TodayCancel.vue'
      ),
  },
  {
    path: '/history/month/confirm',
    name: 'HistoryMonthConfirm',
    component: () =>
      import(
        /* webpackChunkName: "historyMonthConfirm" */ '../views/history/MonthConfirm.vue'
      ),
  },
  {
    path: '/history/month/cancel',
    name: 'HistoryMonthCancel',
    component: () =>
      import(
        /* webpackChunkName: "historyMonthCancel" */ '../views/history/MonthCancel.vue'
      ),
  },
];

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes,
});

// 2026-07-31 보안감사 - beforeEnter: requireAuth가 결제 3개 라우트에만 붙어있고 나머지(정산/매장관리/
// 관리자관리/통계/예약/이력 등 가맹점 매니저 전용 화면)는 라우트 레벨 보호가 전혀 없었음(Header.vue의
// mounted() 리다이렉트+axios 9999 인터셉터에만 의존). meta.public으로 표시한 라우트를 제외한 전체에
// 로그인(토큰) 여부를 강제한다.
router.beforeEach((to, from, next) => {
  if (!to.meta.public && !store.state.token) {
    next({ path: '/signin' });
    return;
  }
  next();
});

export default router;
